<script setup lang="ts">
import tenkoAssociationType from "@/types/responses/getIttenkoAssociation";
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue";
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { useAuth } from "@/services/user/Auth0UserProvider";
import Api from "@/services/api/ApiServiceFabrick";
import { Ref, ref, computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'success', 'deleteFailed']);
const props = defineProps<{
  modelValue: boolean;
  tenkoAssociation: tenkoAssociationType | null;
}>();

const { loginWithRedirect } = useAuth()
const loading: Ref<boolean> = ref(false);
const deletable: Ref<boolean> = ref(true);
const flashMessage: Ref<{ message: string, show: boolean, type: string, cancel: boolean }> = ref({
  message: '',
  show: false,
  type: '',
  cancel: false,
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function deleteTenkoAssociation() {
  if (!props.tenkoAssociation) {
    return;
  }
  loading.value = true
  Api().deleteTenkoAssociation(props.tenkoAssociation.id).then(() => {
    modelValue.value = false
    loading.value = false
    emits('success');
  }).catch((error) => {
    loading.value = false
    const res = error.response
    switch (res.status) {
      case 401:
        loginWithRedirect({
          appState: { targetUrl: location.pathname },
        });
        break;
      case 403:
        location.reload();
        break;
      case 404:
        deletable.value = false
        displayFlashMessage()
        break;
    }
  });
}

function displayFlashMessage() {
  flashMessage.value.message = i18n.global.t('pages.common.messages.failedRemove')
  flashMessage.value.type = 'error'
  flashMessage.value.show = true
}

function closeModal() {
  if (!deletable.value) {
    return emits('deleteFailed')
  }
  modelValue.value = false
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    :title="i18n.global.t('pages.tenkoAssociation.deleteModal.title')"
  >
    <template v-slot:flash-message>
      <ModalFlashMessage
        :message = "flashMessage.message"
        :show = "flashMessage.show"
        :type = "flashMessage.type"
        :cancel = "flashMessage.cancel"
        @setShow = "(show) => {flashMessage.show = show}"
      />
    </template>
    <template v-slot:content>
      <div class="pt-3">
        {{ i18n.global.t('common.confirmationModal.confirmDelete') }}
      </div>
    </template>
    <template v-slot:buttons>
      <div class="pt-2">
        <v-btn
          @click="closeModal()"
          class="reset-btn mr-2"
          :disabled="loading"
          :style="{
            backgroundColor : loading ? '#B3B8BB' : ''
          }"
        >
          {{ i18n.global.t('common.cancelBtn') }}
        </v-btn>
        <v-btn
          @click="deleteTenkoAssociation"
          class="bg-danger text-white"
          :loading="loading"
          :disabled="!deletable"
        >
          {{ i18n.global.t('common.deleteBtn') }}
        </v-btn>
      </div>
    </template>
  </RegisterModal>
</template>
